import React from "react";
import _ from "lodash";
import classNames from "classnames";
import { useRecoilState } from "recoil";
import { DateTime } from "luxon";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
const CustomerTotals = ({ customer = { Name: "" }, selectCustomer }) => {
  const cartCustomer = useSelector((s) => s.cart.customer || {});
  if (!customer.Name) {
    return null;
  }
  return (
    <>
      <div
        onClick={selectCustomer}
        className={classNames("flex flex-col w-2/12 flex-1 select-none", {
          "is-orange": customer.Name === cartCustomer.Name,
          underline: customer.Name === cartCustomer.Name,
        })}
      >
        <div className="flex justify-start">
          <div style={{ minWidth: 300 }} className="flex flex-col">
            <span className="text-center is-orange text-center text-2xl">
              {toTitleCase(customer.Name.trim())}
              <span className="pb-4 text-black text-center text-xs">
                {" "}
                ({toTitleCase(customer.Custno.trim())}){" "}
              </span>
            </span>
            {customer.ADDR1.trim() && (
              <span className="text-center text-sm">
                {toTitleCase(customer.ADDR1)}, {toTitleCase(customer.CITY)}
              </span>
            )}
          </div>
        </div>
      </div>

      <div
        onClick={selectCustomer}
        className={classNames("ml-2 w-2/12 is-orange text-center select-none", {
          "is-orange": customer.Name === cartCustomer.Name,
        })}
      >
        <h6>{customer.orders}</h6>
        <p className="text-xs text-gray-800">
          {DateTime.fromISO(customer.last_order)
            .plus({ hours: 4 })
            .toRelative()}
        </p>
      </div>
      <div
        className={classNames("ml-2 w-2/12 is-orange text-center select-none")}
        onClick={selectCustomer}
      >
        ${customer.total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
      </div>
      <Link to={`/orders/custno/${customer.Custno}`}>
        <div className={"flex flex-col w-1/12 is-orange w-1/3 select-none"}>
          <span className="text-xs text-gray-700">View Orders</span>
        </div>
      </Link>
    </>
  );
};

export default CustomerTotals;
